<template>
  <footer class="w-full bg-black text-white py-10" style="font-family: 'Helvetica', sans-serif">
    <div class="container mx-auto px-4">
      <div class="grid grid-cols-1 md:grid-cols-7 gap-8">
        <div class="col-span-2">
          <div class="flex items-center space-x-2">
            <img :src = "FuchsjobsLogo" class="max-w-[150px]" alt="Fuchsjobs Logo">
          </div>
          <p class="mt-4" style="font-size: 16px">
            Finde einen Job, der genau zu Dir passt. Oder finden Sie qualifizierte Talente für Ihr Unternehmen.
          </p>
          <div class="mt-4" style="font-size: 16px; font-weight: 600">
            <p class="">
              Tel: <a href="tel:+493075479856">(+49) 30 754 79 856</a>
              <i class="fas fa-phone-alt ml-2"></i>
            </p>
            <p class="mt-2">
              Email: <a href="mailto:info@fuchsjobs.de">info@fuchsjobs.de</a>
              <i class="fas fa-envelope ml-2"></i>
            </p>
          </div>
        </div>

        <div>
          <h3 class="font-bold mb-4">Unternehmen</h3>
          <ul class="space-y-2 text-sm">
            <li><router-link to="/about" class="hover:underline">Über Fuchsjobs</router-link></li>
            <li><router-link to="/#faq" class="hover:underline">Häufige Fragen</router-link></li>
            <li><a href="mailto:info@fuchsjobs.de" class="hover:underline">Kontakt</a></li>
          </ul>
        </div>

        <div>
          <h3 class="font-bold mb-4">Arbeitnehmer</h3>
          <ul class="space-y-2 text-sm">
            <li><router-link to="/user/register" target="_blank" class="hover:underline">Für Jobsuchende</router-link></li>
            <li><a href="#" class="hover:underline">Übersicht Jobs</a></li>
            <li><a href="#" class="hover:underline">Blog</a></li>
            <li><a href="https://headly.ai/" target="_blank" rel="noopener noreferrer" class="hover:underline">KI Bewerbungsfotos</a></li>
          </ul>
        </div>

        <div>
          <h3 class="font-bold mb-4">Arbeitgeber</h3>
          <ul class="space-y-2 text-sm">
            <li><router-link to="/user/register" target="_blank" class="hover:underline">Für Arbeitgeber</router-link></li>            
            <li><a href="#" class="hover:underline">Job posten</a></li>
            <li><router-link to="/landing/about" class="hover:underline">{{ $t('navi.about') }}</router-link></li>      
          </ul>
        </div>

        <div>
          <h3 class="font-bold mb-4">Social</h3>
          <ul class="space-y-2 text-sm">
            <li><a href="https://www.facebook.com/fuchsjobs/" target="_blank" class="hover:underline"><i class="fab fa-facebook"></i> Facebook</a></li>
            <li><a href="https://www.instagram.com/fuchsjobs/" target="_blank" class="hover:underline"><i class="fab fa-instagram"></i> Instagram</a></li>
            <li><a href="https://www.linkedin.com/company/fuchsjobs/" target="_blank" class="hover:underline"><i class="fab fa-linkedin"></i> Linkedin</a></li>
            <li><a href="https://www.youtube.com/@fuchsjobs" target="_blank" class="hover:underline"><i class="fab fa-youtube"></i> YouTube</a></li>
          </ul>
        </div>

        <div>
          <h3 class="font-bold mb-4">Rechtliches</h3>
          <ul class="space-y-2 text-sm">
            <li><router-link to="/datenschutz" class="hover:underline">Datenschutz</router-link></li>
            <li><router-link to="/impressum" class="hover:underline">Impressum</router-link></li>
          </ul>
        </div>
      </div>
      <div class="mt-10 border-t border-gray-700 pt-4 text-center text-sm">
        <p>&copy; {{ currentYear }} Fuchsjobs. Made with 🦊 in Berlin & UK</p>
      </div>
    </div>
  </footer>
</template>

<script>
import FuchsjobsLogo from '@/assets/images/logo/Fuchsjobs_Logo_schwarzweiss.svg';

export default {
  name: 'FooterComponent',
  data() {
    return {
      FuchsjobsLogo : FuchsjobsLogo,
      currentYear: new Date().getFullYear()
    }
  }
};
</script>

<style scoped>
footer {
  background-color:black !important;
  font-size:22px;
  li {
    font-weight: 600;
    font-size: 16px;
  }
}
a:hover {
  background: linear-gradient(45deg, #FF4D00 0%, #EF008A 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-decoration: none !important;
}
</style>
